import React, { useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { CustomerInfo, Page } from '@components';
import AccountInfo from './components/AccountInfo';
import BankStatement from './components/BankStatement';
import CollateralDetail from './components/CollateralDetail';
import LoanDetail from './components/LoanDetail';
import PayoffDetail from './components/PayoffDetail';

const Accounting = () => {
    const {
        AccountingStore: { currentTab, updateData },
    } = useStore();
    useEffect(() => {
        return () => {
            updateData('currentTab', 'ACCOUNT_INFO');
        };
    }, []);

    return (
        <Page>
            <div className="container">
                <CustomerInfo title={'帳務查詢'} />
                <div className="card wow fadeInDown">
                    <div className="card-body tab-content overflow-hidden">
                        <div id="scrol-menu1">
                            <Tabs className="scroller text-nowrap">
                                <div className="fix-scroll table-responsive mb-4">
                                    <TabList className="nav justify-content-around scrol-tabs overflow-hidden fs-6 mw-100">
                                        <Tab
                                            onClick={() => {
                                                updateData(
                                                    'currentTab',
                                                    'ACCOUNT_INFO'
                                                );
                                            }}
                                            className={`scrol-item ${
                                                currentTab === 'ACCOUNT_INFO'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            帳戶資訊
                                        </Tab>
                                        <Tab
                                            onClick={() => {
                                                updateData(
                                                    'currentTab',
                                                    'LOAN_DETAIL'
                                                );
                                            }}
                                            className={`scrol-item ${
                                                currentTab === 'LOAN_DETAIL'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            借款查詢
                                        </Tab>
                                        <Tab
                                            onClick={() => {
                                                updateData(
                                                    'currentTab',
                                                    'PAYOFF_DETAIL'
                                                );
                                            }}
                                            className={`scrol-item ${
                                                currentTab === 'PAYOFF_DETAIL'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            還款查詢
                                        </Tab>
                                        <Tab
                                            onClick={() => {
                                                updateData(
                                                    'currentTab',
                                                    'COLLATERAL_DETAIL'
                                                );
                                            }}
                                            className={`scrol-item ${
                                                currentTab ===
                                                'COLLATERAL_DETAIL'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            擔保品查詢
                                        </Tab>
                                        <Tab
                                            onClick={() => {
                                                updateData(
                                                    'currentTab',
                                                    'BANK_STATEMENT'
                                                );
                                            }}
                                            className={`scrol-item ${
                                                currentTab === 'BANK_STATEMENT'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            對帳單查詢
                                        </Tab>
                                    </TabList>
                                </div>
                                <div className="acc-tabbox tab-content">
                                    <TabPanel>
                                        <AccountInfo />
                                    </TabPanel>
                                    <TabPanel>
                                        <LoanDetail />
                                    </TabPanel>
                                    <TabPanel>
                                        <PayoffDetail />
                                    </TabPanel>
                                    <TabPanel>
                                        <CollateralDetail />
                                    </TabPanel>
                                    <TabPanel>
                                        <BankStatement />
                                    </TabPanel>
                                </div>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
};

export default observer(Accounting);
